import React, { Component, Fragment } from 'react';
import { DetailContainer } from '../DetailContainer';
import Select from 'react-select';
import { Button, Label, Input } from 'reactstrap';
import { formatDate } from '../../invoices/containers/InvoiceDetail';
import Loading from '../../apa/components/Loading';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

@connect(
	state => (
		{
			auth: state.apa
		}
	)
)
export default class CustomerManual extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			manualList: null,
			categoryList: null,
			customer: null,
			newCustomerManual: {
				number: '',
				date: formatDate(new Date()),
				manual: '',
				category: '',
				sector: ''
			}
		}
	}

	componentDidMount() {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const id = this.props.match.params.id;
		fetch(
			'/api/template/categories/',
			{ headers }
		).then(
			res => res.json()
		).then(
			categories => this.setState({
				categoryList: categories,
			})
		)
		fetch(
			`/api/customers/${id}/`
			, { headers })
			.then(res => res.json())
			.then(customer => this.setState({
				customer: customer, isLoading: false
			}))
	}

	@autobind
	submitNewManual() {
		const id = this.props.match.params.id;
		const customer_manual = {
			...this.state.newCustomerManual,
			customer: this.props.match.params.id,
			template: this.state.newCustomerManual.manual.value,
			category: this.state.newCustomerManual.category.value
		};
		if (!customer_manual.template)
			return;

		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const body = JSON.stringify(customer_manual);
		fetch(
			'/api/customer_templates/',
			{ headers, method: 'POST', body }
		).then(
			res => res.json()
		).then(
			() => this.props.history.push(`/customer/${id}/templates`)
		)
	}

	@autobind
	handleNumber(event) {
		const target = event.target;
		const value = target.value;
		const customer_manual = { ...this.state.newCustomerManual, number: value };
		this.setState(
			{
				newCustomerManual: customer_manual
			}
		)
	}

	@autobind
	handleName(name) {
		const customer_manual = { ...this.state.newCustomerManual, sector: name };
		this.setState(
			{
				newCustomerManual: customer_manual
			}
		)

	}

	@autobind
	handleDate(event) {
		const target = event.target;
		const value = target.value;
		const customer_manual = { ...this.state.newCustomerManual, date: value };
		this.setState(
			{
				newCustomerManual: customer_manual
			}
		)
	}

	@autobind
	handleManual(manual) {
		const customer_manual = { ...this.state.newCustomerManual, manual: manual };
		this.setState(
			{
				newCustomerManual: customer_manual
			}
		)
	}

	@autobind
	chooseCategory(categoryOption) {
		const newCustomerManual = { ...this.state.newCustomerManual, category: categoryOption };
		this.setState({
			newCustomerManual: newCustomerManual,
			templateListLoading: true
		});
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		fetch(
			`/api/template/categories/${categoryOption.value}/manuals/`,
			{ headers }
		).then(res => res.json())
			.then(
				manuals => {
					this.setState({
						manualList: manuals,
						templateListLoading: false,
						newCustomerManual: {
							number: this.state.newCustomerManual.number,
							date: this.state.newCustomerManual.date,
							manual: '',
							category: this.state.newCustomerManual.category,
							sector: this.state.newCustomerManual.category.label
						}
					})
				}
			)
	}

	render() {
		if (this.state.isLoading)
			return <Loading />;
		return (
			<DetailContainer id={this.props.match.params.id}>
				<h1>{this.state.customer.name}</h1>
				<Label>
					Nummer
				</Label>
				<Input value={this.state.newCustomerManual.number} onChange={this.handleNumber} />
				<Label>
					Datum
				</Label>
				<Input type='date' value={this.state.newCustomerManual.date} onChange={this.handleDate} />
				<Label>
					Kategorie
				</Label>
				<Select
					onChange={this.chooseCategory} value={this.state.newCustomerManual.category}
					options={
						this.state.categoryList.map(
							category => ({
								value: category.id, label: category.name
							})
						)
					}
				/>
				{
					this.state.templateListLoading &&
					<Loading />
				}
				{
					!this.state.templateListLoading && this.state.manualList &&
					<Fragment>
						<Label>
							Betriebsanweisung
								</Label>
						<Select
							value={this.state.newCustomerManual.manual}
							onChange={this.handleManual}
							options={
								this.state.manualList.map(
									manual => (
										{ value: manual.id, label: manual.name }
									)
								)
							}
						/>
					</Fragment>
				}
				<Label>
					Arbeitsplatz, Tätigkeitsbereich
				</Label>
				<Input type='text' value={this.state.newCustomerManual.sector} onChange={(e) => this.handleName(e.target.value)} />

				<br />
				<Button
					color='primary'
					onClick={this.submitNewManual}>
					Anlegen
									</Button>
			</DetailContainer>
		)
	}
}
